import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac808bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center px-x3 sm:px-x4"
}
const _hoisted_2 = { class: "w-full max-w-600" }

import useProductDetailUpsell from '@/shared/product/upsell/useProductDetailUpsell';
import ProductDetailUpsellItem from '@/shared/product/upsell/ui/ProductDetailUpsellItem.vue';
import Swiper from '@/shared/Swiper.vue';
import { computed } from 'vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import ProductDetailUpsellItemRecommended from '@/shared/product/upsell/ui/ProductDetailUpsellItemRecommended.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailUpsellItems',
  setup(__props) {

const { upsellItems } = useProductDetailUpsell();

const isSingleResult = computed(() => upsellItems.value.length === 1);
const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');
const isTablet = computed(() => breakpointsState.activeBreakpoint === 'sm');
const freeMode = computed(() => isMobile.value || isTablet.value);

const swiperOptions = computed(() => {
    let slidesPerView = 3.6;
    if (isMobile.value) {
        slidesPerView = 1.8;
    } else if (isTablet.value) {
        slidesPerView = 2.8;
    }
    return {
        spaceBetween: 18,
        centerInsufficientSlides: true,
        slidesPerGroup: 3,
        slidesOffsetBefore: 25,
        slidesOffsetAfter: 25,
        slidesPerView,
    };
});


return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!

  return (_unref(isSingleResult))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isSingleResult))
            ? (_openBlock(), _createBlock(ProductDetailUpsellItemRecommended, {
                key: 0,
                item: _unref(upsellItems)[0]
              }, null, 8, ["item"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(Swiper, {
        key: 1,
        "free-mode": _unref(freeMode),
        options: _unref(swiperOptions),
        class: _normalizeClass({ swiper: !_unref(freeMode) })
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(upsellItems), (item, idx) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: item.sku+idx,
              class: "swiper-item"
            }, {
              default: _withCtx(() => [
                (_unref(isSingleResult))
                  ? (_openBlock(), _createBlock(ProductDetailUpsellItemRecommended, {
                      key: 0,
                      item: item
                    }, null, 8, ["item"]))
                  : (_openBlock(), _createBlock(ProductDetailUpsellItem, {
                      key: 1,
                      item: item
                    }, null, 8, ["item"]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["free-mode", "options", "class"]))
}
}

})